import { config } from '../config';

/** 新版入口默认地址，环境变量缺失时兜底。 */
export const DEFAULT_NEW_VERSION_URL = 'https://test-creative.adesk.com/';

/**
 * 额度使用率达到该比例时，提示用户可以改用新版的独立额度。
 * 与 CanvasQuota 的 warning 阈值保持一致。
 */
export const NEW_VERSION_QUOTA_HINT_RATIO = 0.9;

/**
 * 解析新版入口地址。
 * 环境变量可能是空串或非法值，此时回退到内置默认值。
 */
export function resolveNewVersionUrl(configured?: string): string {
  const candidate = (configured ?? config.newVersionUrl ?? '').trim();
  if (!candidate) return DEFAULT_NEW_VERSION_URL;

  try {
    const url = new URL(candidate);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return DEFAULT_NEW_VERSION_URL;
    return url.toString();
  } catch {
    return DEFAULT_NEW_VERSION_URL;
  }
}

/**
 * 在新标签页打开新版入口。
 * 使用 noopener 切断对新窗口的引用，避免被跳转页反向控制当前页面。
 */
export function openNewVersion(url: string = resolveNewVersionUrl()): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * 额度是否已接近用尽（达到 90%）。
 * 不限额（limit 为 null/undefined）或数据非法时不提示。
 */
export function isQuotaNearLimit(used: number, limit: number | null | undefined): boolean {
  const usedValue = Number(used);
  const limitValue = limit === null || limit === undefined ? null : Number(limit);
  if (!Number.isFinite(usedValue) || usedValue < 0) return false;
  if (limitValue === null || !Number.isFinite(limitValue) || limitValue <= 0) return false;
  return usedValue / limitValue >= NEW_VERSION_QUOTA_HINT_RATIO;
}